// A no-break space, so a narrow screen never wraps "60,000" and "mi" onto separate lines.
export const MILES_UNIT = "\u00A0mi";

/** "98120" → "98,120 mi"; anything that is not a plain number is shown as typed. */
export const formatMiles = (miles?: string | null): string | null => {
  const value = miles?.trim();
  if (!value) return null;
  const number = Number(value.replace(/,/g, ""));
  return `${Number.isFinite(number) ? number.toLocaleString("en-US") : value}${MILES_UNIT}`;
};

/** "84,200" → 84200; null for anything that is not a whole number of miles above zero. */
export const parseMiles = (miles?: string | null): number | null => {
  const digits = (miles ?? "").replace(/[,\s]/g, "");
  if (!/^\d+$/.test(digits)) return null;
  const number = Number(digits);
  return number > 0 && Number.isSafeInteger(number) ? number : null;
};

// Stored mileage is typed by hand: also read "88,210 mi", "88210 miles" or "88210.5", rounded to whole miles.
export const parseStoredMiles = (miles?: string | null): number | null => {
  const match = /^([\d,]+(?:\.\d+)?)\s*(?:mi|miles)?\.?$/i.exec((miles ?? "").trim());
  if (!match) return null;
  const number = Math.round(Number(match[1].replace(/,/g, "")));
  return number > 0 && Number.isSafeInteger(number) ? number : null;
};

// "88,210 mi" as typed shows once as "88,210 mi", not with a second unit.
export const formatStoredMiles = (miles?: string | null): string | null => {
  const parsed = parseStoredMiles(miles);
  return parsed === null ? formatMiles(miles) : formatMiles(String(parsed));
};
